export const API_METHODS = {
  get: 'GET',
  post: 'POST',
  delete: 'DELETE',
  put: 'PUT',
};

export const API_KEYS = {
  logging: 'logging',
  invite: 'invite',
};

export const API_URLS = {
  finalizeInvite: 'token/finalize',
  log: '/event',
  terms: 'contractTerms',
  validate: 'token/validate',
  verifyZipCode: 'token/verifyZipCode',
};

export const API_ROUTES = {
  // LOGGING APIs ----
  // Swagger: https://services.qa5.xfinity.com/comcast-logging/api/help/
  [API_KEYS.logging]: {
    key: API_KEYS.logging,
    endpoints: {
      log: {
        url: API_URLS.log,
        method: API_METHODS.post,
        key: API_KEYS.logging,
      },
    },
  },

  // Invite API ---
  [API_KEYS.invite]: {
    key: API_KEYS.invite,
    endpoints: {
      finalizeInvite: {
        url: API_URLS.finalizeInvite,
        method: API_METHODS.post,
        key: API_KEYS.invite,
      },
      terms: {
        url: API_URLS.terms,
        method: API_METHODS.get,
        key: API_KEYS.invite,
      },
      validate: {
        url: API_URLS.validate,
        method: API_METHODS.post,
        key: API_KEYS.invite,
      },
      verifyZipCode: {
        url: API_URLS.verifyZipCode,
        method: API_METHODS.post,
        key: API_KEYS.invite,
      },
    },
  },
};
